export default __webpack_public_path__ + "static/media/assign-column-active.eb6bdb94.svg";